export const FileIcon = ({ size = 18, color = '#979797', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill={color}
        d="M10.5 1.5h-6c-.825 0-1.493.675-1.493 1.5L3 15c0 .825.667 1.5 1.492 1.5H13.5c.825 0 1.5-.675 1.5-1.5V6l-4.5-4.5Zm3 13.5h-9V3h5.25v3.75h3.75V15Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
